import { Model, Message } from '../types/chat';
import { useTenantStore } from '../stores/useTenantStore';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const getApiBaseUrl = (): string => {
    const baseUrl = useTenantStore.getState().getBaseUrl();
    return baseUrl || 'http://localhost:5000';
};

export const fetchAvailableModels = async (): Promise<Model[]> => {
  try {
    const apiBaseUrl = getApiBaseUrl();

    const response = await fetchWithAuth(`${apiBaseUrl}/v1/models`);

    if (!response.ok) {
      throw new Error('Failed to fetch models');
    }
    const data = await response.json();

    console.log('API Response for models:', data);

    // Handle different response structures
    let modelsArray;
    if (Array.isArray(data)) {
      modelsArray = data;
    } else if (data.data && Array.isArray(data.data)) {
      modelsArray = data.data;
    } else if (data.models && Array.isArray(data.models)) {
      modelsArray = data.models;
    } else {
      console.error('Unexpected API response structure:', data);
      modelsArray = [];
    }

    return modelsArray.map((model: any) => {
      console.log('Processing model:', model);
      const processedModel = {
        id: model.id || model.name || 'unknown',
        name: model.name || model.id || 'Unknown Model',
        description: model.description || `${model.name || model.id || 'Unknown'} language model`,
        metadata: model.metadata || undefined
      };
      console.log('Processed model:', processedModel);
      return processedModel;
    });
  } catch (error) {
    console.error('Error fetching models:', error);
    throw error;
  }
};

export async function* streamChatMessage(
  messages: Message[],
  modelId: string
): AsyncGenerator<string, void, unknown> {
  try {
    const apiBaseUrl = getApiBaseUrl();

    const response = await fetchWithAuth(`${apiBaseUrl}/v1/chat/completions`, {
      method: 'POST',
      body: JSON.stringify({
        model: modelId,
        messages: messages.map(msg => ({
          role: msg.role,
          content: msg.content
        })),
        stream: true
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body?.getReader();
    if (!reader) {
      throw new Error('Response body is not readable');
    }

    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();

      if (done) {
        break;
      }

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');

      // Garde la dernière ligne partielle dans le buffer
      buffer = lines.pop() || '';

      for (const line of lines) {
        const trimmedLine = line.trim();

        if (trimmedLine === 'data: [DONE]') {
          return;
        }

        if (trimmedLine.startsWith('data: ')) {
          try {
            const jsonStr = trimmedLine.slice(6); // Remove "data: "
            const data = JSON.parse(jsonStr);

            if (data.choices?.[0]?.delta?.content) {
              console.log('Yielding chunk:', data.choices[0].delta.content);
              yield data.choices[0].delta.content;
            }
          } catch (parseError) {
            // Ignore malformed JSON chunks
            console.warn('Failed to parse streaming chunk:', parseError);
          }
        }
      }
    }
  } catch (error) {
    console.error('Error streaming chat message:', error);
    throw error;
  }
}